const styles = {
  metrics: {
    width: '100% !important',
    marginBottom: '1rem !important',
  },
  chart: {
    marginBottom: '1rem !important',
  },
};

export default styles;
